<script setup> 
  import CurrentConditionsDataList from "@/components/CurrentConditionsDataList.vue";
  import CurrentConditionsDataSource from "@/components/CurrentConditionsDataSource.vue";

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    allowedDataValues: {
      type: Array,
      default: () => []
    },
    tagList: {
      type: Boolean,
      default: false
    },
    hideSource: {
      type: Boolean,
      default: false
    }
  });
</script>

<template>
  <CurrentConditionsDataList
    :upgrade="props.upgrade"      
    :tagList="props.tagList"
    :allowedDataValues="props.allowedDataValues"
  />
  <CurrentConditionsDataSource v-if="!props.hideSource" />
</template>